import { useRef, useState } from "react";
import { CheckCircle2, Send } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const blank = { first_name: "", last_name: "", email: "", phone: "", company: "", message: "", privacy: false, website: "" };
const privacyUrl = () => new URLSearchParams(window.location.search).get("privacy");

const Field = ({ id, label, children }) => (
  <div className="space-y-1.5"><Label htmlFor={id} className="text-xs font-semibold text-slate-700">{label}</Label>{children}</div>
);

export default function WebFormPage() {
  const [f, setF] = useState(blank);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const started = useRef(Date.now());
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      await api.post("/public/web-request", { ...f, phone: f.phone || null, company: f.company || null, started_at: started.current, page: document.referrer || null,
        tenant: new URLSearchParams(window.location.search).get("a") || null });
      setDone(true);
    } catch (x) { setErr(errorMessage(x)); } finally { setBusy(false); }
  };
  if (done) return (
    <div className="flex min-h-[320px] flex-col items-center justify-center gap-3 p-6 text-center" data-testid="webform-success">
      <CheckCircle2 className="h-10 w-10 text-emerald-600" />
      <p className="text-lg font-semibold text-slate-900">Grazie, richiesta inviata.</p>
      <p className="text-sm text-slate-600">Ti ricontatteremo al più presto.</p>
    </div>);
  const pu = privacyUrl();
  return (
    <form onSubmit={submit} className="mx-auto grid max-w-2xl gap-4 bg-white p-5 sm:grid-cols-2" data-testid="webform">
      <Field id="wf-fn" label="Nome *"><Input id="wf-fn" required maxLength={80} value={f.first_name} onChange={set("first_name")} data-testid="webform-first-name" /></Field>
      <Field id="wf-ln" label="Cognome *"><Input id="wf-ln" required maxLength={80} value={f.last_name} onChange={set("last_name")} data-testid="webform-last-name" /></Field>
      <Field id="wf-em" label="Email *"><Input id="wf-em" type="email" required maxLength={254} value={f.email} onChange={set("email")} data-testid="webform-email" /></Field>
      <Field id="wf-ph" label="Telefono"><Input id="wf-ph" type="tel" maxLength={40} value={f.phone} onChange={set("phone")} data-testid="webform-phone" /></Field>
      <div className="sm:col-span-2"><Field id="wf-co" label="Azienda (lascia vuoto se privato)"><Input id="wf-co" maxLength={200} value={f.company} onChange={set("company")} data-testid="webform-company" /></Field></div>
      <div className="sm:col-span-2"><Field id="wf-msg" label="Come possiamo aiutarti? *"><Textarea id="wf-msg" required minLength={5} maxLength={3000} rows={5} value={f.message} onChange={set("message")} data-testid="webform-message" /></Field></div>
      <input type="text" name="website" tabIndex={-1} autoComplete="off" value={f.website} onChange={set("website")} className="absolute left-[-9999px] h-0 w-0 opacity-0" aria-hidden="true" />
      <label className="flex items-start gap-2 text-xs text-slate-600 sm:col-span-2">
        <input type="checkbox" required checked={f.privacy} onChange={set("privacy")} className="mt-0.5 h-4 w-4" data-testid="webform-privacy" />
        <span>Acconsento al trattamento dei dati personali per essere ricontattato{pu ? <> (<a href={pu} target="_blank" rel="noreferrer" className="underline">informativa privacy</a>)</> : ""}. *</span>
      </label>
      {err && <p className="text-sm text-red-600 sm:col-span-2" data-testid="webform-error">{err}</p>}
      <div className="sm:col-span-2"><Button type="submit" disabled={busy} className="w-full sm:w-auto" data-testid="webform-submit"><Send className="mr-2 h-4 w-4" />{busy ? "Invio…" : "Invia richiesta"}</Button></div>
    </form>
  );
}
